import React, { useContext } from 'react';
import { SiteDataContext } from 'App';
import { NavLink } from 'react-router-dom';
import { Box, constants, Loading } from '@match/react-component-library';
import { SITECODE } from '@match/app-rules-resolver';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useContactDetails } from 'modules/hooks';
import { ContactUsSC3 } from './ContactUsSC3';
import { ContactUsSC8 } from './ContactUsSC8';
import { ContactUsSC10 } from './ContactUsSC10';
import styled from 'packages/theming';

const { SPACE } = constants;

interface ContactUsPageProps {
  isMobi?: boolean;
}

const ContactUsPage: React.FunctionComponent<ContactUsPageProps> = ({ isMobi }) => {
  const { siteCode } = useContext(SiteDataContext);

  if (siteCode === SITECODE.JAPAN) {
    return <ContactUsSC3 />;
  } else if (siteCode === SITECODE.LAT_AM) {
    return <ContactUsSC8 />;
  } else if (siteCode === SITECODE.STIR) {
    return <ContactUsSC10 isMobi={isMobi} />;
  } else {
    return <ContactUsPageGeneralContent isMobi={isMobi} />;
  }
};

const ContactUsPageGeneralContent: React.FunctionComponent<ContactUsPageProps> = ({ isMobi }) => {
  const { contactDetails, isLoading } = useContactDetails();
  const { siteCode } = useContext(SiteDataContext);
  const isLatam = siteCode === SITECODE.LAT_AM;

  if (isLoading) {
    return <Loading />;
  }

  // TODO move the latam link to a hook or something reusable
  if (isLatam) {
    window.location.href = `https://${window.location.hostname}/help/contactusindex.aspx?lid=4`;
  }

  return isLoading || isLatam ? (
    <Loading />
  ) : (
    <Box paddingX={isMobi ? SPACE.LARGE : undefined}>
      {contactDetails.email.available && (
        <Box display="flex" paddingBottom={SPACE.SMEDIUM}>
          <StyledNavLink to="/contact-us/email">
            <FormattedMessage {...messages.email} />
          </StyledNavLink>
        </Box>
      )}
      {contactDetails.chat.available && (
        <Box display="flex">
          <StyledNavLink to="/contact-us/chat">
            <FormattedMessage {...messages.chat} />
          </StyledNavLink>
        </Box>
      )}
    </Box>
  );
};

const StyledNavLink = styled(NavLink)(({ theme }) => ({
  background: theme.palette.core1_100,
  borderRadius: theme.radii.round,
  color: theme.palette.light,
  padding: theme.space.medium,
  width: 160,
  textAlign: 'center',
  [':visited']: {
    color: theme.palette.light,
  },
  [':hover']: {
    textDecoration: 'none',
    background: theme.palette.core1_50,
  },
}));

const messages = defineMessages({
  email: {
    id: 'src/modules/pages/ContactUsPage/ContactUsPage:email',
    description: 'button text to email support',
    defaultMessage: 'Email us',
  },
  chat: {
    id: 'src/modules/pages/ContactUsPage/ContactUsPage:chat',
    description: 'button text to chat with support',
    defaultMessage: 'Chat with us',
  },
});

export default ContactUsPage;
